import { useState } from "react";
import { DEVICE_TYPES } from "../../../common/constant/common-constants";
import { ALARM_PRIORITY } from "../../../common/constant/common-constants";
import { handleOutsideClick } from "../../../common/utils/CommonUtils";
import moment from 'moment';
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";

// import low-priority from "../../../common/icons/alarm/low-priority-alarm.png";
import './DevicesTab.scss'
import { PATIENT_TYPE } from "../../../common/ENUMS/PARAMETER_ENUM";
import { TEMP_MODE } from "../../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { activeDeviceAction } from "../../../modules/actions/action";
import { connect } from "react-redux";

function DevicesTab({ alarmData, handleSeeAllAlarms, activeVitalDevice, modeData, ...props }) {
    const [showMoreAlarms_1, setShowMoreAlarms_1] = useState(null);
    const [showMoreAlarms_2, setShowMoreAlarms_2] = useState(null);



    const getAlarmPriorityClass = (alarmData) => {
        // let id = bedId && bedId.toString();
        switch (alarmData?.priority?.toLocaleUpperCase()) {
            case "HIGH":
                return ALARM_PRIORITY.HIGH_PRIORITY;
            case "MEDIUM":
                return ALARM_PRIORITY.MEDIUM_PRIORITY;
            case "LOW":
                return ALARM_PRIORITY.LOW_PRIORITY;
            default:
                return ALARM_PRIORITY.LOW_PRIORITY;
        }
    }

    const handleShowMoreAlarmsClick_1 = (event) => {
        event.stopPropagation();
        setShowMoreAlarms_1(!showMoreAlarms_1);
        if (!showMoreAlarms_1) {
            handleOutsideClick(event, 'alarm-display-bar-1', setShowMoreAlarms_1);
        }
    }

    const handleShowMoreAlarmsClick_2 = (event) => {
        event.stopPropagation();
        setShowMoreAlarms_2(!showMoreAlarms_2);
        if (!showMoreAlarms_2) {
            handleOutsideClick(event, 'alarm-display-bar-2', setShowMoreAlarms_2);
        }
    }

    // console.log("alarmData----->", alarmData)
    const ventilatorConnected = props.ventilatorHeartbeat?.isConnected;
    const ventilationStatus = props.ventilatorStandby?.ventilationStatus;
    const monitorConnected = props?.monitorHeartBeatData?.isConnected
    const deviceAlarmData = activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5'] ? (monitorConnected ? alarmData?.PM_alarms : []) : ventilatorConnected ? alarmData?.ventilatorAlarms : [];
    // console.log("activeVitalDevice----->", activeVitalDevice)
    // console.log("deviceAlarmData----->", deviceAlarmData)
    


    // console.log("Alarm-tab data------------------------------------------------->", deviceAlarmData.alarms__technical[0]?.message)
    return (
        <div className='machine-tabs-wrap'>

            {activeVitalDevice === DEVICE_TYPES['NOCCARC_PM_NX5'] ? (
                <div className="patient-monitor-alarm">

                    <div className="mode-container-1">
                        {deviceAlarmData?.alarms_physiological?.length ?
                            <div className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData.alarms_physiological[0])}`}
                                onClick={(event) => handleShowMoreAlarmsClick_1(event)}
                                id="alarm-display-bar-1"
                            >
                                {
                                    <>
                                        <div className="top-alarm-container">


                                            {deviceAlarmData.alarms_physiological[0]?.message}


                                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                                {deviceAlarmData.alarms_physiological?.length}
                                                {showMoreAlarms_1 ?
                                                    <img
                                                        style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                        src={deviceAlarmData.alarms_physiological[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow}
                                                        className="arrow-icon" alt="accordion arrow"
                                                    />
                                                    :
                                                    <img
                                                        style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                        src={deviceAlarmData.alarms_physiological[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow}
                                                        className="arrow-icon" alt="accordion arrow"
                                                    />
                                                }
                                            </div>
                                        </div>
                                        {showMoreAlarms_1 &&
                                            <div className="more-alarm-container">

                                                {
                                                    deviceAlarmData.alarms_physiological.map((alarm, count) => {
                                                        if (count > 3) return;
                                                        return (
                                                            <div className="alarm more-alarm" key={count}>
                                                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                    <img src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`} style={{ width: '20px', height: '20px', marginRight: '10px' }} alt="alarm icon" />
                                                                    {
                                                                        alarm.message
                                                                    }
                                                                </div>
                                                                <span className="alarm-time">{alarm.time && moment(alarm.time).format("HH:mm:ss")}</span>
                                                            </div>
                                                        );

                                                    })
                                                }
                                                <div className="see-all-container" onClick={() => handleSeeAllAlarms()}>
                                                    See all
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                            :
                            <div style={{ width: '58%', marginRight: '12px' }} />
                        }

                    </div>

                    <div className="mode-container-2">
                        {deviceAlarmData?.alarms__technical?.length ?
                            <div className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData.alarms__technical[0])}`}
                                onClick={(event) => handleShowMoreAlarmsClick_2(event)}
                                id="alarm-display-bar-2"
                            >
                                {
                                    <>
                                        <div className="top-alarm-container">


                                            {deviceAlarmData.alarms__technical[0]?.message}


                                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                                {deviceAlarmData.alarms__technical?.length}
                                                {showMoreAlarms_2 ?
                                                    <img
                                                        style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                        src={deviceAlarmData.alarms__technical[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow}
                                                        className="arrow-icon" alt="accordion arrow"
                                                    />
                                                    :
                                                    <img
                                                        style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                        src={deviceAlarmData.alarms__technical[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow}
                                                        className="arrow-icon" alt="accordion arrow"
                                                    />
                                                }
                                            </div>
                                        </div>
                                        {showMoreAlarms_2 &&
                                            <div className="more-alarm-container">

                                                {
                                                    deviceAlarmData.alarms__technical.map((alarm, count) => {
                                                        if (count > 3) return;
                                                        return (
                                                            <div className="alarm more-alarm" key={count}>
                                                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                    <img src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`} style={{ width: '20px', height: '20px', marginRight: '10px' }} alt="alarm icon" />
                                                                    {
                                                                        alarm.message
                                                                    }
                                                                </div>
                                                                <span className="alarm-time">{alarm.time && moment(alarm.time).format("HH:mm:ss")}</span>
                                                            </div>
                                                        );

                                                    })
                                                }
                                                <div className="see-all-container" onClick={() => handleSeeAllAlarms()}>
                                                    See all
                                                </div>
                                            </div>
                                        }
                                    </>
                                }
                            </div>
                            :
                            <div style={{ width: '58%', marginRight: '12px' }} />
                        }
                    </div>




                </div>
            ) : (

                <div className="mode-container-3">
                    {/* {modeData?.modesParameter?.modeName && <img src={adult} alt="patient type" />} */}
                    <div className="mode-details">
                        <h2 className="mode">{(ventilatorConnected && ventilationStatus && activeVitalDevice !== DEVICE_TYPES['MONITOR']) ? `${TEMP_MODE[modeData?.modesParameter?.modeName]?.mode} ${PATIENT_TYPE[modeData?.modesParameter?.patientType]}` : '  '}</h2>
                        {/* <h3 className="mode mt-4">PID: 8765</h3> */}
                    </div>
                    {deviceAlarmData?.length ?
                        <div className={`alarm-container ${getAlarmPriorityClass(deviceAlarmData[0])}`}
                            onClick={(event) => handleShowMoreAlarmsClick_1(event)}
                            id="alarm-display-bar-1"
                        >
                            {
                                <>
                                    <div className="top-alarm-container">
                                        {deviceAlarmData[0]?.name}
                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                            {deviceAlarmData?.length}
                                            {showMoreAlarms_1 ?
                                                <img
                                                    style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                    src={deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteUpArrow : blackUpArrow}
                                                    className="arrow-icon" alt="accordion arrow"
                                                />
                                                :
                                                <img
                                                    style={{ marginLeft: '6px', width: '0.833vw', height: '0.833vw' }}
                                                    src={deviceAlarmData[0]?.priority?.toLocaleUpperCase() === "HIGH" ? whiteDownArrow : blackDownArrow}
                                                    className="arrow-icon" alt="accordion arrow"
                                                />
                                            }
                                        </div>
                                    </div>
                                    {showMoreAlarms_1 &&
                                        <div className="more-alarm-container">
                                            {
                                                deviceAlarmData.map((alarm, count) => {
                                                    if (count > 3) return;
                                                    return (
                                                        <div className="alarm more-alarm" key={count}>
                                                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                                <img src={`/assets/icons/alarm/${getAlarmPriorityClass(alarm)}-alarm.png`} style={{ width: '20px', height: '20px', marginRight: '10px' }} alt="alarm icon" />
                                                                {alarm.name}
                                                            </div>
                                                            <span className="alarm-time">{alarm.startObservedAt && moment(alarm.startObservedAt , "YYYYMMDDHHmmss").format("HH:mm:ss")}</span>
                                                        </div>
                                                    );
                                                })
                                            }
                                            <div className="see-all-container" onClick={() => handleSeeAllAlarms()}>
                                                See all
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                        :
                        <div style={{ width: '58%', marginRight: '12px' }} />
                    }
                </div>

            )}





            <div className='device-select-btn-container'>
                <div
                    className={`device-btn ${props?.bedDetails?.Noccarc_patientMonitorId ? props.config.activeDevice === DEVICE_TYPES.NOCCARC_PM_NX5 ? "active-device-component" : "" : "disabled"}`}
                    onClick={() => { props?.bedDetails?.Noccarc_patientMonitorId ? props.activeDeviceAction(DEVICE_TYPES.NOCCARC_PM_NX5) : console.log('Device not configered') }}
                >
                    PATIENT MONITOR
                </div>
                <div
                    className={`device-btn ${props?.bedDetails?.ventilatorId ? props.config.activeDevice === DEVICE_TYPES.VENTILATOR ? "active-device-component" : "" : "disabled"}`}
                    onClick={() => { props?.bedDetails?.ventilatorId ? props.activeDeviceAction(DEVICE_TYPES.VENTILATOR) : console.log('Device not configered') }}
                >
                    VENTILATOR
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    let bedDetails = state.bedDetailsReducer.bedDetails[ownProps.bedId];
    let ventilatorHeartbeat = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId];
    let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    let mData = state?.deviceVitalDataReducer?.deviceVitalData?.[ownProps.bedId]?.[DEVICE_TYPES.MONITOR];
    let mHeartBeatData = state?.deviceVitalDataReducer?.monitorHeartbeat?.[ownProps.bedId];
    return {
        bedDetails: bedDetails,
        ventilatorHeartbeat: ventilatorHeartbeat,
        ventilatorStandby: ventilatorStandby,
        config: state.configReducer.config,
        monitorData: mData,
        monitorHeartBeatData: mHeartBeatData,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        activeDeviceAction: (payload) => dispatch(activeDeviceAction(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicesTab);